module.exports = __webpack_public_path__ + "static/media/hot3.bcc8b0da.jpg";